import UnsplashImage from 'components/shared/UnsplashImage'
import moment from 'moment'
import React from 'react'
import { publicUrl } from 'utils/urls'

interface HeroProps {
	space: any
	subject: any
	organisation: any
}
interface AuthLayoutProps {
	title: string
	children: React.ReactNode
	childrenClassName?: string
	childPadding?: boolean
	mainClassName?: string
	heroImage?: HeroProps
}

const Hero = (props: HeroProps): JSX.Element => {
	const { space, subject, organisation } = props
	return (
		<div className="relative z-20 bg-gray-900 mt-4">
			<div className="container mx-auto px-4 pt-10 pb-12 relative z-20">
				<div className="w-full md:w-1/2">
					{subject && (
						<span className="text-sm whitespace-nowrap rounded-full inline-block bg-purple-900 text-white relative z-10 px-3 py-1 mb-2 font-semibold">
							{subject?.attributes?.title}
						</span>
					)}
					<h1 className="text-3xl font-semibold mb-3 mt-0 text-white">
						{space.attributes.title}
					</h1>
					<div className="flex flex-col items-start mb-4 opacity-90">
						{space.attributes.useChallenges && (
							<span className="text whitespace-nowrap text-white uppercase">
								Period:{' '}
								{moment(space.attributes.challengeStartDate).format(
									'DD-MM-YYYY'
								)}{' '}
								-{' '}
								{moment(space.attributes.challengeEndDate).format('DD-MM-YYYY')}
							</span>
						)}
						{organisation && (
							<a
								href={publicUrl(
									`/challenge-spaces/organisation/${organisation.attributes.slug}`
								)}
								className="mt-1 text-white text-opacity-100 font-bold cursor-pointer hover:text-opacity-75 transition-colors duration-300"
							>
								{organisation.attributes.name}
							</a>
						)}
					</div>
				</div>
			</div>
			<div className="bg-gradient-to-b md:bg-gradient-to-r z-10 absolute from-gray-900 h-1/2 md:h-full right-0 bottom-0 top-auto md:top-0 w-full md:w-7/12"></div>
			<div className="absolute right-0 bottom-0 top-auto md:top-0 h-1/2 md:h-full w-full md:w-7/12">
				<UnsplashImage
					{...(space.attributes.unsplash ?? {})}
					title={space.attributes.title}
					width="1900"
					height="1000"
				/>
			</div>
		</div>
	)
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
	title,
	children,
	childrenClassName = 'px-4 border mt-10 rounded-lg max-w-xl',
	childPadding = true,
	mainClassName = 'md:justify-center',
	heroImage,
}) => {
	return (
		<div className="wrapper bg-white min-h-screen">
			<main
				className={`w-full min-h-screen py-12 flex flex-col items-center ${mainClassName}`}
			>
				<div className="w-full max-w-lg flex justify-center mx-auto">
					<img
						className="block w-52 ml-4"
						src="/static/img/logo_masterchallenge.png"
						alt="Logo Masterchallenge"
					/>
				</div>
				<div className={`mx-auto relative z-10 w-full ${childrenClassName}`}>
					<div className="bg-white mx-auto rounded-lg overflow-hidden pt-6">
						{heroImage && <Hero {...heroImage} />}
						{title && (
							<h1
								className={`font-sans font-bold text-3xl mb-3 px-8 py-4 text-center ${
									heroImage ? 'mt-4' : ''
								}`}
							>
								{title}
							</h1>
						)}

						<div className={childPadding ? 'px-8 pt-6 pb-8 mb-4' : ''}>
							{children}
						</div>
					</div>
				</div>
			</main>
		</div>
	)
}

export default AuthLayout
